import {Injectable} from "@angular/core";
import {environment} from "../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class MercureService {
  private subscriptions = [];

  subscribe(topic): EventSource {
    const es = MercureService.connect(topic);
    this.subscriptions.push(es);
    return es;
  }

  unsubscribe(): void {
    this.subscriptions.forEach(s => s.close());
  }

  static connect(topic): EventSource {
    return new EventSource(MercureService.getUrlFor(topic));
  }

  private static getUrlFor(topic): URL {
    const url = new URL(environment.mercureUrl);
    url.searchParams.append('topic', topic);
    return url;
  }
}
